import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { userService } from '../services/userService';
import type { CreateUserDto } from '../types';

export function useCreateUser() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('users');

  return useMutation({
    mutationFn: (data: CreateUserDto) => userService.createUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success({ title: t('toasts.createSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.createError') });
    },
  });
}
